import * as consts from '@/constants.js';

export default {
  dataRacesStatus: consts.REQUEST_WITHOUT_STARTING,
  races: [],
};
